<app-chi-siamo-it *ngIf="global.culture == 'it'"></app-chi-siamo-it>
<app-chi-siamo-en *ngIf="global.culture == 'en'"></app-chi-siamo-en>
<app-chi-siamo-es *ngIf="global.culture == 'es'"></app-chi-siamo-es>
<app-chi-siamo-fr *ngIf="global.culture == 'fr'"></app-chi-siamo-fr>
